import {Selector} from "./selectorType";
import StoreState from "../../interfaces/store/storeState";
import {Editors} from "../../interfaces/common";

export const selectEditors: Selector<Editors> = (({serviceProperties: {editors}}: StoreState): Editors => editors);
